import React, { Component, cloneElement } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Tooltip from '../tooltip';

class DropdownMenu extends Component {
  static displayName = 'NeatUI.DropdownMenu';

  static propTypes = {
    prefixCls: PropTypes.string,
    className: PropTypes.string,
    /** 默认值 */
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    /** 是否显示菜单 */
    defaultIsOpen: PropTypes.bool,
    /** 显示状态改变时回调 function(isOpen) */
    onOpenChange: PropTypes.func,
    /** 挂载点 */
    anchorEl: PropTypes.element,
    // onChange: PropTypes.func,
    /** 选中时菜单项时回调 function(event, value) */
    onSelect: PropTypes.func,
    /** 弹出位置 */
    position: PropTypes.string,
    /** 选中后是否自动关闭 */
    noClose: PropTypes.bool,
    /** 禁止操作 */
    disabled: PropTypes.bool,
    /** 触发方式 */
    trigger: PropTypes.oneOf(['click', 'hover', 'focus']),
    /** 根据挂载点宽度设置菜单宽度 */
    autoWidth: PropTypes.bool,
  };

  static defaultProps = {
    prefixCls: 'ne-drop-down-menu',
    defaultIsOpen: false,
    trigger: 'focus',
    position: 'bottomLeft',
    noClose: false,
    disabled: false,
    autoWidth: false,
  };

  static getDerivedStateFromProps(props, state) {
    if (props.defaultIsOpen !== state.prevIsOpen) {
      return {
        isOpen: props.defaultIsOpen,
        prevIsOpen: props.defaultIsOpen,
      };
    }
    return null;
  }

  constructor(props) {
    super(props);
    const { isOpen, defaultIsOpen } = props;
    this.isControlled = isOpen != null;
    if (!this.isControlled) {
      this.state = {
        prevIsOpen: defaultIsOpen,
        isOpen: defaultIsOpen,
      };
    }
  }

  onOpen = () => {
    const { onOpenChange } = this.props;
    if (!this.isControlled) {
      this.setState({
        isOpen: true,
      });
    }
    onOpenChange && onOpenChange(true);
  };

  onClose = () => {
    const { onOpenChange } = this.props;
    if (!this.isControlled) {
      this.setState({
        isOpen: false,
      });
    }
    onOpenChange && onOpenChange(false);
  };

  close = () => {
    this.setState({
      isOpen: false,
    });
  };

  render() {
    const {
      defaultIsOpen,
      prefixCls,
      className,
      placeholder,
      children,
      defaultValue,
      disabled,
      trigger,
      anchorEl,
      onSelect,
      onChange,
      isOpen: propIsOpen,
      noClose,
      ...other
    } = this.props;
    const { isOpen } = this.state;
    const menu = cloneElement(children, {
      onSelect: (...args) => {
        const menuSelect = onSelect || children.props.onSelect;
        menuSelect && menuSelect(...args);
        !noClose && this.close();
      },
      onChange: onChange || (children.props && children.props.onChange),
      defaultValue: defaultValue || (children.props && children.props.defaultValue),
    });
    const classes = classNames(prefixCls, className);
    return (
      <Tooltip
        content={anchorEl}
        isOpen={this.isControlled ? propIsOpen : isOpen}
        trigger={!disabled ? trigger : 'none'}
        prefixCls={prefixCls}
        className={classes}
        onOpen={this.onOpen}
        onClose={this.onClose}
        autoAdjustPosition
        {...other}>
        {menu}
      </Tooltip>
    );
  }
}
export default DropdownMenu;



// WEBPACK FOOTER //
// ./src/dropdownMenu/DropdownMenu.jsx